import React from "react";

export const UserHeadsetIcon = ({ width, height, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448 512"
    >
      <path
        fill={fill}
        d="M314.7 352H133.3C59.7 352 0 411.7 0 485.3C0 500.1 11.94 512 26.66 512H421.3C436.1 512 448 500.1 448 485.3C448 411.7 388.3 352 314.7 352zM50.7 464c9.498-36.76 42.95-64 82.64-64h181.3c39.69 0 73.14 27.24 82.64 64H50.7zM224 112c44.11 0 80 35.89 80 80c0 19.39-7.217 36.96-18.74 50.82c3.922 3.928 7.296 8.294 10.1 13.13L304 256c17.11 0 32.02-9.09 40.52-22.6C349 220.3 352 206.6 352 192c0-70.58-57.42-128-128-128s-128 57.42-128 128c0 40.41 19.12 76.03 48.37 99.49C144.3 290.3 144 289.2 144 288c0-17.62 7.164-33.6 18.73-45.19C151.2 228.9 144 211.4 144 192C144 147.9 179.9 112 224 112zM48 224C56.88 224 64 216.9 64 208V192c0-88.25 71.75-160 160-160s160 71.75 160 160v16C384 252.1 348.1 288 304 288h-32c0-17.62-14.38-32-32-32h-32c-17.62 0-32 14.38-32 32s14.38 32 32 32h96c61.88-.125 111.9-50.13 112-112V192c0-105.9-86.13-192-192-192S32 86.13 32 192v16C32 216.9 39.13 224 48 224z"
      />
    </svg>
  );
};
